import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { PublishedCardComponent } from './components/published-card/published-card.component';
import { EnumToArrayPipe } from './services/enumToArray';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule
  ],
  exports: [
    MaterialModule,
    FlexLayoutModule,
    CountdownTimerComponent,
    PublishedCardComponent,
    EnumToArrayPipe
  ],
  declarations: [CountdownTimerComponent, PublishedCardComponent, EnumToArrayPipe]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts